export enum VolunteerHoursRequestTypes {
    GetTags = 'get-service-entry-tags',
    GetOrganizationVolunteerServiceData = 'get-org-vol-service-data',
    GetVolunteerServiceData = 'get-vol-service-data',
    GetOrganizationServiceData = 'get-org-service-data',
    UpsertServiceEntries = 'upsert-service-entries',
    BulkEdit = 'bulk-edit-service-entries'
}